import UserManagerService from './UserManagerService';

class ErrorResponseHandler {
  public defaultHandler(error: any) {
    if (error.response && error.response.status) {
      this.reLoginOnUnauthorized(error.response.status);
    }
  }

  private signinRedirect = () => {
    const userManager = UserManagerService.userManager;
    userManager.signinRedirect({
      useReplaceToNavigate: true,
      state: window.location.pathname,
    });
  };

  private reLoginOnUnauthorized(status: number) {
    if (status === 401) {
      this.signinRedirect();
    }
  }
}

export default new ErrorResponseHandler();
